import { useRecoilValue, useSetRecoilState } from 'recoil';

import useQueryHook from '@/hooks/useQueryHook';
import { loginState } from '@/recoil';
import { enrolledQuestionCnt } from '@/recoil/ina';
import { API, URLs } from '@/api';

export const GetEnrolledQuestionList = () => {
    const loginStatus = useRecoilValue(loginState);
    const setTodayEnrolledQuestionCnt = useSetRecoilState(enrolledQuestionCnt);

    useQueryHook(
        ['enrolledQuestionList', loginStatus.clientId],
        async () => {
            return await API.get(URLs.ina.today);
        },
        {
            onSuccess: questionList => {
                setTodayEnrolledQuestionCnt(questionList.length);
            },
            cacheTime: Infinity,
            staleTime: Infinity,
        },
    );
};
